var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.publisher_profiles)?_c('publisher-profiles-table',{staticClass:"mt-3",attrs:{"headers":_vm.headers,"publisher_profiles":_vm.publisher_profiles}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }